import { useMemo, useRef } from "react";
import { RootState } from "redux/store";
import { useAppSelector } from "redux/hooks";
import { eChartColours, getMainColors } from "constants/colors";
import { Row, Col, Card } from "react-bootstrap";
import { formatToAUD } from "helpers/numbersFormater";
import ReactECharts from 'echarts-for-react';
import { EChartsOption } from "echarts";

function PreferredBrands() {
    const dashboard = useAppSelector((state: RootState) => state.dashboard);
    const colors = getMainColors();
    const chartRef = useRef<ReactECharts>(null);

    const chartOptions: EChartsOption = useMemo<EChartsOption>(() => {

        const data = dashboard.preferredBrand.total ? Math.round(dashboard.preferredBrand.count / dashboard.preferredBrand.total * 100) : 0;

        const retData: EChartsOption = {
            color: eChartColours,
            animationDuration: 300,
            series: [
                {
                    type: 'gauge',
                    center: ['50%', '50%'],
                    startAngle: 230,
                    endAngle: -45,
                    radius: '100%',
                    min: 0,
                    max: 100,
                    progress: {
                        show: true,
                        width: 10
                    },
                    pointer: {
                        show: false
                    },
                    axisLine: {
                        lineStyle: {
                            width: 10
                        }
                    },
                    axisTick: {
                        show: false
                    },
                    splitLine: {
                        show: false
                    },
                    axisLabel: {
                        show: false
                    },
                    anchor: {
                        show: false
                    },
                    title: {
                        show: false
                    },
                    detail: {
                        valueAnimation: true,
                        width: '60%',
                        lineHeight: 40,
                        fontSize: 35,
                        fontWeight: 'normal',
                        formatter: '{value}%',
                        color: '#c0c5cb',
                        offsetCenter: [0, 0],
                    },
                    data: [
                        {
                            value: data
                        }
                    ]
                },
            ],
            tooltip: {
                formatter: 'Preferred Brands: {c}%'
            },
            toolbox: {
                feature: {
                    saveAsImage: {
                        title: 'Save',
                        name: `Preferred Brand Export`,
                    },
                }
            },
            legend: {
                show: true,
                name: 'Preferred Brand'

            }
        };

        return retData;
    }, [dashboard.customerData]);

    return (
        <Card style={{ marginBottom: "0px", height: '100%' }}>
            <Card.Body className="ps-2 d-flex flex-column">
                <Row className="p-0">
                    <Col xl={6} className="ps-2">
                        <h4 className="dasboard-widget-title">Preferred Brands <i className="ps-1 widget-icon mdi mdi-currency-usd"></i></h4>
                    </Col>
                    <Col xl={6} className="p-0">
                    </Col>
                </Row>

                <Row className="d-flex flex-grow pt-1">
                    <ReactECharts
                        ref={chartRef}
                        option={chartOptions}
                        className="h-100 w-100 d-flex flex-grow"
                    />
                </Row>

                <Row className="pt-3 pb-3">
                    <p className="text-center fw-normal text-muted mb-0">{dashboard.preferredBrand.message[0] ? dashboard.preferredBrand.message[0] : "0/0 scripts"}</p>
                    <p className="text-center fw-normal text-muted mb-0"><strong>Lost Profit: </strong>{dashboard.preferredBrand.message[1] ? formatToAUD(dashboard.preferredBrand.message[1]) : "0.00"}</p>
                </Row>

            </Card.Body>
        </Card >
    );
};

export default PreferredBrands;
